import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, NgModule } from '@angular/core';
import { TuiTiptapEditorService } from '@taiga-ui/addon-editor/directives';
import { TUI_EDITOR_TOOLBAR_TEXTS } from '@taiga-ui/addon-editor/tokens';
import { map } from 'rxjs/operators';
import * as i1 from '@taiga-ui/core';
import { TuiHostedDropdownModule, TuiDropdownModule, TuiButtonModule, TuiHintModule } from '@taiga-ui/core';
import * as i2 from '@taiga-ui/addon-editor/components/toolbar-tools/table-size-selector';
import { TuiTableSizeSelectorModule } from '@taiga-ui/addon-editor/components/toolbar-tools/table-size-selector';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@taiga-ui/addon-editor/abstract';
import * as i5 from 'rxjs';

class TuiTableCreateComponent {
    constructor(editor, texts$) {
        this.editor = editor;
        this.texts$ = texts$;
        this.insertTableText$ = this.texts$.pipe(map(texts => texts.insertTable));
    }
    addTable({ rows, cols }) {
        this.editor.enter(); // @note: clear previous styles
        const prevLine = this.editor.state.selection.anchor;
        // @note: don't use `setHardBreak`,
        // it inherits styles of previous lines
        // required two line after
        this.editor.enter();
        this.editor.enter();
        this.editor.setTextSelection(prevLine);
        this.editor.insertTable(rows, cols);
    }
}
TuiTableCreateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateComponent, deps: [{ token: TuiTiptapEditorService }, { token: TUI_EDITOR_TOOLBAR_TEXTS }], target: i0.ɵɵFactoryTarget.Component });
TuiTableCreateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiTableCreateComponent, selector: "tui-table-create", ngImport: i0, template: "<tui-hosted-dropdown\n    #table\n    tuiDropdownAlign=\"left\"\n    tuiDropdownDirection=\"bottom\"\n    [content]=\"tableDropdown\"\n>\n    <button\n        tuiIconButton\n        type=\"button\"\n        size=\"s\"\n        icon=\"tuiIconTableLarge\"\n        appearance=\"icon\"\n        tuiHintDirection=\"top-left\"\n        tuiHintDescribe\n        [tuiHint]=\"insertTableText$ | async\"\n        [focusable]=\"table.open\"\n    ></button>\n</tui-hosted-dropdown>\n\n<ng-template #tableDropdown>\n    <tui-table-size-selector (onSelectSize)=\"addTable($event)\"></tui-table-size-selector>\n</ng-template>\n", components: [{ type: i1.TuiHostedDropdownComponent, selector: "tui-hosted-dropdown", inputs: ["content", "sided", "canOpen", "open"], outputs: ["openChange", "focusedChange"] }, { type: i1.TuiButtonComponent, selector: "button[tuiButton], button[tuiIconButton], a[tuiButton], a[tuiIconButton]", inputs: ["appearance", "disabled", "icon", "iconRight", "shape", "showLoader", "size"] }, { type: i2.TuiTableSizeSelectorComponent, selector: "tui-table-size-selector", outputs: ["selectSize", "onSelectSize"] }], directives: [{ type: i1.TuiDropdownOptionsDirective, selector: "[tuiDropdownAlign], [tuiDropdownAppearance], [tuiDropdownDirection], [tuiDropdownLimitWidth], [tuiDropdownMinHeight], [tuiDropdownMaxHeight], [tuiDropdownOffset]", inputs: ["tuiDropdownAlign", "tuiDropdownAppearance", "tuiDropdownDirection", "tuiDropdownLimitWidth", "tuiDropdownMinHeight", "tuiDropdownMaxHeight", "tuiDropdownOffset"] }, { type: i1.TuiHintDescribeDirective, selector: "[tuiHintDescribe]", inputs: ["tuiHintDescribe"] }, { type: i1.TuiHintDirective, selector: "[tuiHint]:not(ng-container)", inputs: ["tuiHint", "tuiHintContext", "tuiHintAppearance"] }, { type: i1.TuiHintDriverDirective, selector: "[tuiHint]" }, { type: i1.TuiHintHoverDirective, selector: "[tuiHint]:not(ng-container)", inputs: ["tuiHintShowDelay", "tuiHintHideDelay"], exportAs: ["tuiHintHover"] }, { type: i1.TuiHintPositionDirective, selector: "[tuiHint]:not([tuiHintCustomPosition])", inputs: ["tuiHintDirection"] }], pipes: { "async": i3.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-table-create',
                    templateUrl: './table-create.template.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i4.AbstractTuiEditor, decorators: [{
                    type: Inject,
                    args: [TuiTiptapEditorService]
                }] }, { type: i5.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_EDITOR_TOOLBAR_TEXTS]
                }] }]; } });

class TuiTableCreateModule {
}
TuiTableCreateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiTableCreateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateModule, declarations: [TuiTableCreateComponent], imports: [CommonModule,
        TuiHostedDropdownModule,
        TuiDropdownModule,
        TuiButtonModule,
        TuiHintModule,
        TuiTableSizeSelectorModule], exports: [TuiTableCreateComponent] });
TuiTableCreateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateModule, imports: [[
            CommonModule,
            TuiHostedDropdownModule,
            TuiDropdownModule,
            TuiButtonModule,
            TuiHintModule,
            TuiTableSizeSelectorModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableCreateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TuiHostedDropdownModule,
                        TuiDropdownModule,
                        TuiButtonModule,
                        TuiHintModule,
                        TuiTableSizeSelectorModule,
                    ],
                    declarations: [TuiTableCreateComponent],
                    exports: [TuiTableCreateComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTableCreateComponent, TuiTableCreateModule };
